import { RequestStatusEnum, RequestTypeEnum } from "@collections/request-info/enums/request-info.enums";

export class RequestInfoModel {
    message: string;
    company: string;
    lang: string;
    telephone: string;
    requestType: RequestTypeEnum;
    email: string;
    recipientCompany?: string;
    requestStatus: RequestStatusEnum;
    originalMessage: string;
    recipientNews?: string;
    recipientProduct?: string;
}